<template>  
  <div>                
     <template v-if="loaded">   
      <coverage-time-line :coverageIteration="coverageIteration" :uiid="uiid" />
      <!-- <mission-simulation-line-detail :uiid="uiid" :mission="missionDetail" v-if="(vimStatus == 10 || (coverageIteration.result && coverageIteration.result.error_msg && coverageIteration.result.error_msg.startsWith('Battery limit'))) &&  typeUiid=='detail'"  />         -->
      <!-- <h2 class="body-2 text-uppercase primary--text" v-if="(vimStatus == 10 || (coverageIteration.result && coverageIteration.result.error_msg && coverageIteration.result.error_msg.startsWith('Battery limit'))) && typeUiid=='detail' ">{{$t('Simulation.Result')}}</h2>                      -->      
      <div v-for="(gkey,idx) in gliderKeys" >
        <hr v-if="idx>0" class="text-gray-200" /> 
        <coverage-iteration-line-detail-glider :mission="coverageIteration?.resultAloMission?.[gkey]"  :uiid="uiid" :glider="gkey" :class="{'bg-gray-100':idx%2==0}" />                                        
      </div>
      <hr  class="mt-2 text-gray-200" /> 
      <div class="bg-blue-100 !pt-1" v-if="coverageIteration?.missionStartDate">
      <h2 class="body-2 text-uppercase primary--text"  >{{$t('Simulation.Result')}} </h2>                     
        <table class="mrs-tbl" cellspacing="0" >
          <thead>
            <tr>          
              <td>{{$t('Pilot.MissionDrawer.Distance')}}</td>
              <td>{{$t('Simulation.StartDate')}}</td>
              <td>{{$t('Simulation.EndDate')}}</td>
              <td>{{$t('Pilot.MissionDrawer.MissionDuration')}}</td>
              <td>{{$t('Simulation.CyclesNb')}}</td>
              <td>{{$t('Simulation.EnergyAvailable')}} (%)</td>                                
            </tr>
          </thead>
          <tr>
              <td>{{ (coverageIteration?.distance_traveled ?? 0) * 1000 | formatDistance }}</td> 
              <td>{{coverageIteration?.missionStartDate | formatDate("DD/MM/YYYY HH:mm:ss") }}</td>
              <td>{{ coverageIteration?.missionCurEndDate | formatDate("DD/MM/YYYY HH:mm:ss") }}</td>
              <td>{{ [coverageIteration?.missionStartDate , coverageIteration?.missionCurEndDate] | formatDuree($i18n) }}</td>
              <td>{{ coverageIteration?.nbYos }}</td>
              <td>{{ coverageIteration?.energy_available  }} </td>    
            </tr>
        </table>     
      </div>
      <!-- <template v-if="showError"><br/><strong>{{$t("Simulation.Error")}} :</strong> <span class="red--text darken-1">{{ coverageIteration.result.error_msg }}</span></template>               -->
    </template>    
    <template  v-else>
      {{$t("Pilot.MissionDrawer.Loading")}}
      <v-progress-linear indeterminate color="primary" ></v-progress-linear>      
    </template>     
  </div>        
</template>
<script setup lang="ts">
  
  import { ref,computed, onMounted } from 'vue'
  import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
  import CoverageTimeLine from '@/components/smart/Coverage/CoverageTimeLine.vue'
  import  CoverageIterationLineDetailGlider  from '@/components/smart/Coverage/CoverageIterationLineDetailGlider.vue'  
  import { CoverageState, getCoverageState } from '@/enum/CoverageState';
  import store from '@/store';

  
  const props = defineProps<{
      coverageIteration:AloDbCoverageIteration,  
      uiid:string
    }>()

  const loaded = ref(false)
  const gliderKeys = computed(()=>Object.keys(props.coverageIteration?.resultMipJson || {}).filter(n => n.startsWith('GLIDER')))
  

  onMounted(()=>{            
    if(getCoverageState(props.coverageIteration?.COV_PROCESSING_STATE) == CoverageState.running) { 
      //console.log('coverage iteration running try to get her updated status')
      store.myActions.COVERAGEITERATION_PROGRESSION_REQUEST({itemId:props.coverageIteration.id!,migTyp:store.myGetters.modifiedAdmMissionGlobal.MIG_TYP} ).then(()=>loaded.value = true)
    }
    else{
      loaded.value = true
    }
  })  

</script> 

<style scoped>


</style>
